var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }